import { lazy } from "react";
import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Weather",
  description: "Weather information widget",
  category: "Widget",
  grid: {
    "small": [1, 1],
    "medium": [2, 1],
    "large": [4, 3],
    "very large": [4, 4],
  },
  app: lazy(() =>
    import("./DetailView").then(m => ({ default: m.WeatherDetailView })),
  ),
  setup: lazy(() =>
    import("./Settings").then(m => ({ default: m.WeatherSettings })),
  ),
  defaultProps: {
    units: "metric",
  },
} as ElementDetails;
